import { SharingTipId } from 'owa-sharing-data';

export default {
    AttachmentCreateComposeLinkView: { datapoint: { name: 'AttachmentCreateComposeLinkView' } },
    AttachmentLinkViewChangePermission: {
        datapoint: { name: 'AttachmentLinkViewChangePermission' },
    },
    AttachmentLinkViewChangePermissionSharingDialog: {
        datapoint: { name: 'AttachmentLinkViewChangePermissionSharingDialog' },
    },
    AttachmentLinkViewEditLink: { datapoint: { name: 'AttachmentLinkViewEditLink' } },
    AttachmentLinkViewRevertToFullUrl: { datapoint: { name: 'AttachmentLinkViewRevertToFullUrl' } },
    AttachmentLinkMultipleSharingTipsShown: {
        datapoint: { name: 'AttachmentLinkMultipleSharingTipsShown' },
    },
    AttachmentLinkSharingTipIgnored: {
        datapoint: {
            name: 'AttachmentLinkSharingTipIgnored',
            customData: (sharingTipId: SharingTipId) => [sharingTipId],
        },
    },
};
